export default __webpack_public_path__ + "static/media/icon3.48428420.png";